import { TaskName } from '@/common/constants/taskNames.constants';
import { TaskState } from '@schema';
import i18n from '@/common/i18n';
import type { TaskMap } from '@/common/store/modules/tasks/tasksNotificationMapper';

const taskMap: TaskMap = {
  [TaskName.NODE_RELEASE]: {
    [TaskState.SUCCESS]: () => ({
      message: i18n.t('Data migration is in progress. The node will be released as soon as all data is migrated.'),
    }),
    [TaskState.RUNNING]: () => ({
      message: i18n.t('Releasing node...'),
    }),
    [TaskState.FAILED]: ({ error }) => ({
      title: i18n.t('Error releasing node'),
      message: error
    })
  },
  [TaskName.NODE_JOIN_TO_CLUSTER]: {
    [TaskState.SUCCESS]: () => ({
      title: i18n.t('Node joined to storage cluster'),
      message: i18n.t('Node successfully joined to storage cluster'),
    }),
    [TaskState.RUNNING]: () => ({
      message: i18n.t('Joining node to storage cluster...'),
    }),
    [TaskState.FAILED]: ({ error }) => ({
      title: i18n.t('Error joining node to storage cluster'),
      message: error
    })
  },
  [TaskName.NODE_ENTER_TO_MAINTENANCE]: {
    [TaskState.SUCCESS]: () => ({
      title: i18n.t('Node entered maintenance mode'),
      message: i18n.t('Node successfully entered maintenance mode'),
    }),
    [TaskState.RUNNING]: () => ({
      message: i18n.t('Entering maintenance mode...'),
    }),
    [TaskState.FAILED]: ({ error }) => ({
      title: i18n.t('Error entering maintenance mode'),
      message: error
    })
  },
  [TaskName.NODE_EXIT_MAINTENANCE]: {
    [TaskState.SUCCESS]: () => ({
      title: i18n.t('Node exited maintenance mode'),
      message: i18n.t('Node successfully exited maintenance mode'),
    }),
    [TaskState.RUNNING]: () => ({
      message: i18n.t('Exiting maintenance mode...'),
    }),
    [TaskState.FAILED]: ({ error }) => ({
      title: i18n.t('Error exiting maintenance mode'),
      message: error
    })
  },
};

export default taskMap;
